import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  AUIFilterBar,
  AUIClearFilter,
  AUISearchFilter,
  AUIWrapperFilter,
  AUISelectFilter,
  AUICalendarFilter,
} from '@ancert/aui-filter-bar';
import { AUITable } from '@ancert/aui-table';
import ModalReestablecerContrasena from '../../components/ModalReestablecerContrasena';
import { getDenuncias } from '../../services/denuncias.service';
import getColumns from './columns';
import { ROUTES } from '../../constants/routes.constants';
import { SELECT_OPTIONS, localFilterData, generateFilter } from './filter';
import { useLoading } from '../../context/loading.context';
import { useSession } from '../../context/session.context';
import { PAGE_SIZE } from '../../config';
import { ROL } from '../../lib/role.enum';

const ListadoDenuncia = () => {
  const history = useHistory();
  const tableRef = useRef(null);
  const { getRenewPassword, setUniqueComplaint, getUser } = useSession();
  const { role } = getUser();
  const { isLoading, setIsLoading } = useLoading();
  const [isShow, setShow] = useState(false);
  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState(null);
  const dataFiltered = localFilterData({
    data,
    filter: dataFilter,
    idPermission: [ROL.ADMINISTRADOR, ROL.RESPONSABLE].includes(role),
  });

  const redirectConsulta = (id) => {
    history.push(`${ROUTES.CONSULTAR_DENUNCIA}/${id}`);
  };

  const getDatosDenuncias = async () => {
    const denuncias = await getDenuncias();
    if (denuncias.status === 200) {
      if (denuncias.data.length === 1) {
        setUniqueComplaint(true);
        redirectConsulta(denuncias.data[0].complaint.publicId);
        return;
      }
      setUniqueComplaint(false);
      setShow(getRenewPassword());
      setData(denuncias.data);
    } else {
      setData([]);
    }
  };

  const onApplyFilter = (filter) => {
    const applyFilter = generateFilter(filter);
    setDataFilter(applyFilter);
    tableRef.current.resetPagination();
  };

  useEffect(() => {
    setIsLoading(true);
    getDatosDenuncias();
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return null;
  }

  return (
    <div className="o-sii-main-container">
      <p className="u-mt-8">
        A continuación, encontrará un listado con todas la denuncias que ha realizado, seleccione una denuncia para ver
        más información.
      </p>
      <h1>Listado de denuncias</h1>
      <AUIFilterBar
        tagBar
        onSubmit={onApplyFilter}
        onReset={() => {
          setDataFilter(null);
        }}
      >
        <AUIWrapperFilter position="left">
          <AUISearchFilter name="id" tag="ID" placeholder="Buscar por ID" />
        </AUIWrapperFilter>
        <AUIWrapperFilter position="center">
          <AUICalendarFilter name="date" label="Fecha denuncia" selectionMode="range" />
          <AUISelectFilter label="Estado" name="status" options={SELECT_OPTIONS} />
        </AUIWrapperFilter>
        <AUIWrapperFilter position="right">
          <AUIClearFilter label="Reiniciar filtros" />
        </AUIWrapperFilter>
      </AUIFilterBar>
      <AUITable
        ref={tableRef}
        className="u-mt-16"
        idData="complaint.id"
        columns={getColumns(redirectConsulta, [ROL.ADMINISTRADOR, ROL.RESPONSABLE].includes(role))}
        forcePagination
        data={dataFiltered}
        pageSize={PAGE_SIZE.LISTADO_DENUNCIAS}
        totalData={dataFiltered?.length}
      />
      <ModalReestablecerContrasena show={isShow} onClose={() => setShow(false)} />
    </div>
  );
};

export default ListadoDenuncia;
